import { render, staticRenderFns } from "./taskDeliverModify-02.vue?vue&type=template&id=dceaf90a&scoped=true"
import script from "./taskDeliverModify-02.vue?vue&type=script&lang=js"
export * from "./taskDeliverModify-02.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverModify-02.vue?vue&type=style&index=0&id=dceaf90a&prod&lang=css"
import style1 from "./taskDeliverModify-02.vue?vue&type=style&index=1&id=dceaf90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceaf90a",
  null
  
)

export default component.exports